import React, { useEffect, useState } from 'react';
import { Sidebar } from 'primereact/sidebar';
import { ProgressSpinner } from 'primereact/progressspinner';
import {
  JOB_FIELD_LABELS,
  JOB_HISTORY_ACTIONS,
  apiErrorMessage,
  formatDateTime,
  historyValue,
  useCareersRequest,
} from './careersShared';

// Long text fields only say they changed instead of printing both versions
const LONG_FIELDS = ['description'];

function Changes({ changes, categoryNames }) {
  const entries = Object.entries(changes || {});
  if (!entries.length) return null;
  return (
    <ul className="careers-history-changes">
      {entries.map(([field, { from, to }]) => (
        <li key={field}>
          <strong>{JOB_FIELD_LABELS[field] || field}</strong>
          {LONG_FIELDS.includes(field) ? (
            <span> updated</span>
          ) : (
            <span>
              {': '}
              <span className="text-muted text-decoration-line-through">{historyValue(field, from, categoryNames)}</span>
              {' → '}
              <span>{historyValue(field, to, categoryNames)}</span>
            </span>
          )}
        </li>
      ))}
    </ul>
  );
}

/** Right-hand panel with a job's audit trail. Opens when `job` is set. */
export default function JobHistory({ job, categories = [], onHide }) {
  const request = useCareersRequest();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const categoryNames = Object.fromEntries(categories.map((c) => [c.category_id, c.name]));

  useEffect(() => {
    if (!job) return undefined;
    let cancelled = false;
    setLoading(true);
    setError('');
    request(`/jobs/${job.job_id}/history`)
      .then((data) => { if (!cancelled) setRows(data.history || []); })
      .catch((err) => { if (!cancelled) setError(apiErrorMessage(err, 'Could not load the history.')); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [job, request]);

  return (
    // <Sidebar visible={Boolean(job)} position="right" onHide={onHide} className="resp_sidewidth careers-dialog" style={{ width: '32rem' }}>
    //   <h2 className="careers-card-title mb-1"><i className="pi pi-history" aria-hidden="true" />History</h2>
    //   <p className="careers-subtitle mt-0 mb-4">{job?.title}</p>
    //   {loading && <div className="text-center py-4"><ProgressSpinner style={{ width: 40, height: 40 }} /></div>}
    //   {error && <p className="text-danger">{error}</p>}
    //   {!loading && !error && !rows.length && <p className="text-muted">No history yet.</p>}
    //   {!loading && !error && rows.length > 0 && (
    //     <ol className="careers-timeline">
    //       {rows.map((row) => (
    //         <li key={row.history_id}>
    //           <div className="d-flex justify-content-between gap-2">
    //             <span className="careers-timeline-title">{JOB_HISTORY_ACTIONS[row.action] || row.action}</span>
    //             <span className="careers-timeline-when">{formatDateTime(row.createdAt)}</span>
    //           </div>
    //           <span className="careers-meta">by {row.actor_name || 'Unknown'}</span>
    //           {row.action !== 'duplicated' && <Changes changes={row.changes} categoryNames={categoryNames} />}
    //         </li>
    //       ))}
    //     </ol>
    //   )}
    // </Sidebar>

    <Sidebar
      visible={Boolean(job)}
      position="right"
      onHide={onHide}
      className="resp_sidewidth careers-dialog p-3"
      style={{ width: '32rem' }}
      content={({ hide }) => (
        <div className="careers-history-layout">
          {/* Fixed Header */}
          <div className="careers-history-header">
            <div className="border-bottom pb-2 mb-4">
              <h2 className="careers-card-title mb-1">
                <i className="pi pi-history me-2" aria-hidden="true" />
                History
              </h2>
              <p className="careers-subtitle mb-0">
                {job?.title}
              </p>
            </div>

            <button
              type="button"
              className="p-sidebar-close p-link ps-2"
              style={{ padding: '10px'}}
              onClick={hide}
              aria-label="Close history"
            >
              <i className="pi pi-times" />
            </button>
          </div>

          {/* Scrollable Body */}
          <div className="careers-history-body">
            {loading && (
              <div className="text-center py-4">
                <ProgressSpinner style={{ width: 40, height: 40 }} />
              </div>
            )}

            {error && <p className="text-danger">{error}</p>}

            {!loading && !error && !rows.length && (
              <p className="text-muted">No history yet.</p>
            )}

            {!loading && !error && rows.length > 0 && (
              <ol className="careers-timeline">
                {rows.map((row) => (
                  <li key={row.history_id}>
                    <div className="d-flex justify-content-between gap-2">
                      <span className="careers-timeline-title">
                        {JOB_HISTORY_ACTIONS[row.action] || row.action}
                      </span>

                      <span className="careers-timeline-when">
                        {formatDateTime(row.createdAt)}
                      </span>
                    </div>

                    <span className="careers-meta">
                      by {row.actor_name || 'Unknown'}
                    </span>

                    {row.action !== 'duplicated' && (
                      <Changes
                        changes={row.changes}
                        categoryNames={categoryNames}
                      />
                    )}
                  </li>
                ))}
              </ol>
            )}
          </div>
        </div>
      )}
    />
  );
}
